module.exports = __webpack_public_path__ + "img/selection_library.3e983194.png";